import { Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { MatTabChangeEvent } from '@angular/material';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PeakElement } from '../peak-element'
// import { TimerObservable } from 'rxjs/Observable';
import { Observable, Subscription } from 'rxjs/Rx';
import { ChartComponent } from 'angular2-chartjs';

import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

declare var numeric : any;
        // Chromatogram Input

        var tstamp = [0,3,8,20]; //TIME
        var concp = [30,30,100,100]; //SOLVENT Conc. %
        var itera: number;
        var compdata=[ // xxx,     xxx,         MolV, Absorb,pKa,  c1,         c2,       c3,
                      [0.094128039,-0.840853870,256.7,16877.0,4.50,0.001825900,0.0022205,0.00241860],   //SUL
                      [0.115845745,-2.497049303,211.9,10773.0,5.30,0.006776900,0.0030207,-0.0071719],  //PIR
                      [0.072987396,0.0552428310,262.7,11190.0,4.52,0.000425500,0.0122700,0.00100470],   //PHE
                      [0.078695187,1.5862413860,192.2,6793.00,4.15,0.000940180,0.0040900,0.00161520],    //NAPR
                      [0.097626100,1.5713122360,212.2,26831.0,3.70,0.002994700,0.0038886,-0.0021657],     //KETO
                      [0.095900704,0.4006114420,206.8,9511.00,3.99,0.000127930,0.0092620,0.00167780]     //DICL
                    ];
        var u0;
        var t0;
        var coeff;
        var Temp;
        var solventType;
        var pH;

        // Gradient mode
        var tpoint;
        var grads;
        var concfuncs:any;
        var rtfuncg: any;
        var effuncg: any;
        var lambdafun:any;
        var HETPfunc: any;
        var InterP;
        var IntraP;
        var L;
        var dP;
        var A, B,C;
        var Vinj;
        var FlowRate;


@Component({
  selector: 'app-view1',
  templateUrl: './view1.component.html',
  styleUrls: ['./view1.component.css'],
  animations: [trigger(
        'displayChart', [
        transition(':enter', [
          style({opacity: 0}),
          animate('100ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('100ms', style({opacity: 0}))
        ])
      ])]
})

export class View1Component implements OnInit {

  public displayChart : boolean = false;
  public drawGRAD : any;
  public drawISO : any;
  public chartType : any;
  public chartData : any;
  public onClickRun : any;
  public calFunction : any;
  public coeffcall : any;
  public coeff : any;
  public peakArray:any;

  //func script functions
  public VoidTVfunc: any;
  public rtfunc2: any;
  public senfuncs: any;
  public bpfuncs: any;
  public normdisfun: any;
  public peakdet:any;
  public peakTab:any;
  public effuncs: any;
  public xydata: any;
  public xydata2:any;
  public concfuncs: any;
  public rtfuncg: any;
  public concgrad: any;
  public effuncg: any;
  public bpfuncg: any;
  public senfuncg: any;
  public gradodefunc: any;
  public lambdafun: any;
  public HETPfunc: any;
  public numberOnly: any;
  public download: any;
  public drawcurve: any;
  public addrow: any;
  public trackByFn: any;
  public resetChart: any;
  public resetLC: any;
  public stepUp: any;
  public stepDown: any;
  public upIndex: any;
  public downIndex: any;
  public myid: string;

  // Default values

  public columnPara = {Type:"C18",L:150,ID:4.6,PS:5};
  public solventPara = {Type:"ACN",pH:3,Conc:40};
  public systemPara = {Temp:30,Vinj:20,AcqTime:20};
  public advancedPara = {InterP:0.4,IntraP:0.4,A:1,B:2,C:0.05};

  // public AcqTime:number = 15;
  public HPLCmode:string = '0';
  public advanced=false;   //Column Tab enable Advanced
  public solventc:boolean=false;   //tab2 enable solvent c
  public gradMode:boolean=false;   //tab2 enable solvent c
  public tabVisited:boolean=false;
  public FlowRate:number = 1.5;
  //public SPType:string = "C18";
  public Length: number = 150;
  public Diameter: number = 4.6;
  public particleSize: number = 5;
  public InterP: number = 0.4;
  public IntraP: number = 0.4;
  public Temp: number = 20;

  //public Vinj: number = 20;
  //public solventbType:string = "ACN";
  public pHB: number = 3;
  public pHC: number = 3;
  public prentB: number = 50;
  public prentC: number = 50;
  public SULconc: number = 0.1;
  public PIRconc: number = 0.1;
  public PHEconc: number =0.1;
  public NAPconc: number = 0.1;
  public KETconc: number = 0.1;
  public DICconc: number = 0.1;
  public tpoint: number;
  public phaseString: string = "C18";
  public solventString: string = "ACN";
  public ticks:number = 0;
  public LCtime:number;
  public maxabs: number = 4000;
  // public someQuantity:number =1;

  public LCarray=[{time:1,solvent:0.175}];
  // public LCdata=[];

  public solvents:{} = [
         {value: 'MEOH', viewValue: 'MEOH'},
         {value: 'ACN', viewValue: 'ACN'}
         ];

  public phases:{} = [
         {value: "C18", viewValue: "C18"},
         {value: "C18Aq", viewValue: "C18 Aqueous"},
         {value: "C18Ul", viewValue: "C18 Ultra"},
         {value: "C8", viewValue: "C8"},
         {value: "IBD", viewValue: "IBD"},
         {value: "PFPP", viewValue: "PFPP"},
         {value: "BIP", viewValue: "BiPhenyl"}
         ];
  public tstamp: {}; //TIME
  public concp: {}; //SOLVENT Conc. %

   // public tstamp = [0,3,8,20]; //TIME
   // public concp = [30,30,100,100]; //SOLVENT Conc. %

 // -------- LC Time Prog. Tab - Table variables
     public LCColumns = ['time', 'solvent'];
     // LCSource = new MatTableDataSource<LCtable>(this.LCdata);
     // LCSource = new MatTableDataSource<LCtable>(this.LCarray);

 // -------- LC Time Prog. Tab - Chart variables
    public LCtype = 'line';
    public LCdata: any;
    public LCoptions = { legend: {labels: {fontColor: 'rgb(230, 230, 230)'}}, scales: {yAxes: [{ticks: { fontColor: 'rgb(230, 230, 230)'}}], xAxes: [{ticks: { fontColor: 'rgb(230, 230, 230)'}}]}};


    public interval: Subscription;
    public click: Subscription;

    @ViewChild('chart2') chart2: ChartComponent;

// Create an Observable that will publish a value on an interval
// public secondsCounter:Subscription = Observable.interval(1000);
// // Subscribe to begin publishing values
// secondsCounter.subscribe(n =>
//   // console.log(`It's been ${n} seconds since subscribing!`)
// this.onClickRun()
// );



    constructor() {

      // FIXES FOR NUMBER INPUT STEPPERS
      // try calling stepUp() on the input element (Chrome, Firefox, Safari)
// on failure, mimic the effect of stepUp() (Internet Explorer, Edge)
// return immediately if input is disabled

// this.upIndex=function(input:HTMLInputElement) : void {
//   console.log("HTML element", input);
//   if (input.disabled) {
//     return;
//   }
//   try {
//     input.stepUp();
//   }
//   catch (ex) {
//     // increment `value` by `step` (default to '1' if `step` is absent)
//     input.value = String(Number(input.value) + Number(input.step || '1'));
//     // if `max` is present and `value` is greater than `max`, set `value` to `max`
//     if (input.max && Number(input.value) > Number(input.max)) {
//       input.value = input.max;
//     }
//   }
// }

this.stepUp=function(input:HTMLInputElement) : void {
  console.log("HTML element", input);
  if (input.disabled) {
    return;
  }
  try {
    input.stepUp();
  }
  catch (ex) {
    // increment `value` by `step` (default to '1' if `step` is absent)
    input.value = String(Number(input.value) + Number(input.step || '1'));
    input.valueAsNumber = (Number(input.value) + Number(input.step || '1'));

    // if `max` is present and `value` is greater than `max`, set `value` to `max`
    if (input.max && Number(input.value) > Number(input.max)) {
      input.value = input.max;
    }
  }
  // console.log("input.valueAsNumber", input.valueAsNumber);
}

// try calling stepDown() on the input element (Chrome, Firefox, Safari)
// on failure, mimic the effect of stepDown() (Internet Explorer, Edge)
// return immediately if input is disabled
this.stepDown=function(input:HTMLInputElement) : void {
  if (input.disabled) {
    return;
  }
  try {
    input.stepDown();
  }
  catch (ex) {
    // decrement `value` by `step` (default to '1' if `step` is absent)
    input.value = String(Number(input.value) - Number(input.step || '1'));
    // if `min` is present and `value` is less than `min`, set `value` to `min`
    if (input.min && Number(input.value) < Number(input.min)) {
      input.value = input.min;
    }
  }
  tstamp = this.tstamp;
  concp = this.concp;
  tpoint = this.tstamp.length;
}

this.tstamp = [0,3,8,20]; //TIME
this.concp = [30,30,100,100]; //SOLVENT Conc. %
      // FIXES FOR NUMBER INPUT STEPPERS
  this.gradMode=false;
  //---------- timer

  var samplePara = [this.SULconc,this.PIRconc,this.PHEconc,this.NAPconc,this.KETconc,this.DICconc];//[SUL,PIR,PHE,NAP,KET,DIC]
  this.numberOnly = function(event): boolean {
   const charCode = (event.which) ? event.which : event.keyCode;
   console.log(charCode);
   if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=46) {
   return false;
   }
   return true;
 }


 this.download = function(){

   var myElement = document.getElementById('chromatogram');
  //  for (var id in myElement.instances) {
  //   myElement.instances[id].resize()
  // }
   var elWidth = myElement.offsetWidth;
   var elHeight = myElement.offsetHeight;
   // console.log("MYELEMENT, W, H: ", myElement, elWidth, elHeight)
    html2canvas( myElement, { scale: 1, width: elWidth, height: elHeight } ).then(function(canvas) {
    var img = canvas.toDataURL("image/png");
    var doc = new jsPDF( { orientation: 'landscape' , unit: 'pt', format: 'letter' } );
    doc.addImage(img,'JPEG',5,20, 700, 500, false );
    doc.save('chromatogram.pdf');
    });
  }

      this.onClickRun = function(){
        console.log(this.HPLCmode)
        if(this.HPLCmode == '0') { // Isocratic moode
            /*if(!this.solventc){// Single solvent
              null;
              }
              else
              {// Multiple solvents
              this.solventPara.Type = "MEOH";
              this.solventPara.pH = this.pHB;
              this.solventPara.Conc = this.prentB; //Not fixed
            }*/
          }else{// Gradient mode
            tstamp = this.tstamp;
            concp = this.concp;
            tpoint = this.tstamp.length;
          };
          coeff = this.coeffcall(this.solventString,this.phaseString);
          console.log("solventc",this.solventc)
          console.log("SolventB",this.solventString);
          console.log("Phase",this.phaseString);
          this.calFunction(tpoint, coeff, this.tstamp, this.concp);
        };

        this.drawcurve = function() {
          console.log("Drawing curve", this.tstamp, this.concp);
          // this.tstamp = this.tstamp;
          // this.concp = this.concp;
          this.chart2.chart.update();
        }

        this.trackByFn = function (index, item) {
            return index;
        }

        this.addrow = function() {
          this.LCtime = this.tstamp[this.tstamp.length-1];
          // this.LCtime=this.LCtime+1;
          this.tstamp.push(this.LCtime+1);
          this.concp.push(1);

          this.chart2.chart.update();
        }

        this.resetChart = function() {
          this.columnPara = {Type:"C18",L:150,ID:4.6,PS:5};
          this.solventPara = {Type:"ACN",pH:3,Conc:40};
          this.systemPara = {Temp:30,Vinj:20,AcqTime:20};
          this.advancedPara = {InterP:0.4,IntraP:0.4,A:1,B:2,C:0.05};
        }

        this.resetLC = function() {
          this.tstamp = [0,3,8,20];
          this.concp = [30,30,100,100];
          this.LCdata = {
            labels: this.tstamp,
            datasets: [
              {
                borderColor: 'rgb(230, 230, 230)',
                borderWidth:2,
                label: "Solvent Conc %",
                data: this.concp,
                lineTension:0,
              }
            ]
            };
          this.chart2.chart.update();
          // return this.LCdata;
        }

      //FUNC below ------------------------------------------------------------------------------------------------------------------------
      // Isocratic functions
      this.coeffcall = function(solventType,columnType){
      //Data below
      var ACN_C18=[[-4.482973,631.078396,-4.764670,7.963999],
                [-0.878722,194.649688,6.245336,-1.546843],
                [-3.1446748,483.778781,-1.395124,6.485762],
                [-3.713306,496.575343,-4.144739,7.617909],
                [-3.431738,482.969102,-2.521540,6.323179],
                [-3.427969,507.941665,-2.160538,7.037518]];
      var ACN_C18Aq=[[-2.296608,477.935991,6.412758,-0.026647],
                [0.017964,184.849416,11.935544,-5.642432],
                [-2.831418,447.734636,0.578158,5.068236],
                [-2.886890,490.250599,2.203269,3.086675],
                [-2.887796,476.661932,1.726325,3.331015],
                [-2.778376,501.806827,3.620103,3.000004]];
      var ACN_C18Ul=[[-2.721223,368.893390,1.581798,3.442117],
                [-1.640425,307.610809,2.303481,1.488290],
                [-2.314977,365.903562,-0.102931,5.556761],
                [-2.430924,399.191606,1.561520,3.451664],
                [-2.365378,380.347190,1.824854,3.292460],
                [-2.409671,425.524407,1.947519,4.107272]];
      var ACN_IBD=[[-1.325601,393.065907,9.111769,-2.218606],
                [-1.466119,307.176379,1.908059,1.397862],
                [-2.675357,443.155596,-0.110794,5.308507],
                [-2.048054,448.265844,4.582856,1.121499],
                [-1.912695,410.564499,4.688182,1.008902],
                [-2.053667,500.941275,4.610699,1.856949]];
      var ACN_PFPP=[[-3.956585,748.280334,4.638899,1.790935],
                [-1.174476,354.585859,6.120581,-2.225579],
                [-4.529537,787.895749,-2.364145,6.945119],
                [-4.532341,846.527971,0.370268,4.554628],
                [-4.405609,787.272053,0.420975,4.585913],
                [-4.938476,922.312140,-0.512392,5.904548]];
      var ACN_BIP=[[-2.361307,418.012955,5.135169,0.695216],
                [0.536662,33.133737,12.828914,-6.416565],
                [-2.756066,451.085354,1.786521,3.980652],
                [-2.630463,445.163023,3.541866,1.971183],
                [-2.555079,421.120221,3.575024,1.950289],
                [-2.575648,415.459749,3.289273,3.011113]];
      var ACN_C8=[[0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000]];
      var MEOH_C18=[[-3.713050,708.172534,4.506640,3.200922],
                [-2.164328,489.670471,4.848679,0.048011],
                [-3.420687,598.442166,0.945560,5.540639],
                [-3.452080,626.827602,0.832133,4.825746],
                [-3.396381,611.191910,1.891499,4.128107],
                [-4.063225,796.393669,-0.320508,6.645100]];
      var MEOH_C18Aq=[[-3.607037,813.521188,5.215486,2.041321],
                [-2.428149,689.074523,6.114154,-0.977155],
                [-2.586383,464.386883,3.730201,3.045495],
                [-3.173093,655.138417,2.885355,2.767774],
                [-2.853719,567.244586,4.116767,1.952954],
                [-3.453766,734.487777,2.832095,3.776621]];
      var MEOH_C18Ul=[[0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000]];
      var MEOH_IBD=[[-2.195417,604.400891,6.888502,0.597443],
                [-1.072823,346.595024,2.551767,0.611579],
                [-1.439076,469.126195,6.796131,-0.138107],
                [-2.050122,493.925463,2.877597,2.382933],
                [-1.767591,405.450230,3.148777,2.024748],
                [-2.568547,665.345707,2.923421,3.597907]];
      var MEOH_PFPP=[[0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000]];
      var MEOH_BIP=[[-3.770895,955.310141,5.130040,2.315732],
                [-2.528668,761.358920,4.935890,0.228517],
                [-3.267191,764.333032,3.873845,3.195862],
                [-3.203992,740.585041,3.426571,2.523234],
                [-3.200504,745.802812,4.293874,2.224335],
                [-3.341131,756.094508,3.251050,3.751685]];
      var MEOH_C8=[[0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000],
                [0.000000,0.000000,0.000000,0.000000]];
      // Data above
          //Return regression coeff based on solvent and column type
          var coeff;
          switch(solventType){
          case 'ACN':
              switch(columnType){
              case 'C18':coeff = ACN_C18;break;
              case 'C18Aq':coeff = ACN_C18Aq;break;
              case 'C18Ul':coeff = ACN_C18Ul;break;
              case 'IBD':coeff = ACN_IBD;break;
              case 'PFPP':coeff = ACN_PFPP;break;
              case 'BIP':coeff = ACN_BIP;break;
              case 'C8':coeff = ACN_C8;break;
              };
          break;
          case 'MEOH':
              switch(columnType){
              case 'C18':coeff = MEOH_C18;break;
              case 'C18Aq':coeff = MEOH_C18Aq;break;
              case 'C18Ul':coeff = MEOH_C18Ul;break;
              case 'IBD':coeff = MEOH_IBD;break;
              case 'PFPP':coeff = MEOH_PFPP;break;
              case 'BIP':coeff = MEOH_BIP;break;
              case 'C8':coeff = MEOH_C8;break;
              };
          break;
          };
        //console.log("COEFCALL func = ", coeff);
          return coeff;
        }

      this.VoidTVfunc = function(){
          //Return void time, void volume and linear velocity
          var VoidTV=[],TPoro;
          //Void time calculation
          TPoro = this.advancedPara.InterP + this.advancedPara.IntraP * (1-this.advancedPara.InterP);
          VoidTV[0] = TPoro*Math.PI*(this.columnPara.ID*this.columnPara.ID/400)*this.columnPara.L/10; //Column void volume (mL)
          VoidTV[1] = VoidTV[0]/this.FlowRate; //Column void time (min)
          VoidTV[2] = this.columnPara.L/VoidTV[1]; //Linear velocity (mm/min)
          return VoidTV;
      }
      this.rtfunc2=function(coeff,phiB,pH,Temp,i,solventType,columnType,solventc,phiC){
        var RF_iso;
        phiB=phiB/100;
        phiC=phiC/100;
        Temp=Temp+273.15;
        if (!solventc) {
          coeff=this.coeffcall(solventType,columnType);
          //Return retention time based on PNM quad model
          //Input unit conversion
          var PNM;
          switch(solventType){
              case "ACN":PNM=1-2.068*phiB/(1+1.341*phiB);break;
              case "MEOH":PNM=1-1.33*phiB/(1+0.47*phiB);break;
              }
          //Retention model
          var logk=coeff[i][0]+coeff[i][1]/Temp+coeff[i][2]*PNM*PNM+coeff[i][3]*PNM
          +Math.log10(1+Math.pow(10,(pH-compdata[i][4]-phiB*compdata[i][1]))
          /(1+Math.pow(10,(pH-compdata[i][4]-phiB*compdata[i][1])))*(compdata[i][0]-1));
        }
        else {
          //mixture mode
          coeff = [
            [-2.170007,758.025953,2.201010,-4.1701344,0.3940069,-2.5921261,8.0562455], //SUL
            [5.3728582,390.680785,5.137953,-12.4376837,3.9855905,-10.9937807,11.6257884], //PIR
            [-3.933579,611.862699,0.370301,0.012695197,-0.3074848,0.8122618,5.4397561], //PHE
            [-5.070716,636.719202,-0.316299,1.77573850,-1.1498021,2.3499020,3.5651889], //NAP
            [-3.783882,615.549328,0.393148,-0.1708307,-0.4322705,0.54116847,4.8729813], //KET
            [-5.914326,745.980358,-0.259325,2.1716814,-1.869860,3.6946696,3.8177066], //DIC
          ];
          var PNMB,PNMC;
          PNMB=1-2.068*phiB/(1+1.341*phiB);
          PNMC=1-1.33*phiC/(1+0.47*phiC);
          var logk=coeff[i][0]+coeff[i][1]/Temp+coeff[i][2]*PNMB*PNMB+coeff[i][3]*PNMB
          + coeff[i][4]*PNMC*PNMC+coeff[i][5]*PNMC+coeff[i][6]*PNMC*PNMB
          +Math.log10(1+Math.pow(10,(pH-compdata[i][4]-(phiB+phiC)*compdata[i][1]))
          /(1+Math.pow(10,(pH-compdata[i][4]-(phiB+phiC)*compdata[i][1])))*(compdata[i][0]-1));
          console.log("logk_mix",logk)
        }
          return RF_iso = Math.pow(10,logk);
      }

      this.effuncs=function(FlowRate,RtFactor,dP,L,InterDiam,Vinj,A,B,C,phiB,Temp,InterP,IntraP,t0,i,solventType,solventc,phiC){
          //Return efficiency and other results
          var EffResults = [];
          var visco,psi,MB,NFactor;
          // Unit conversion
          Temp = Temp+273.15;
          phiB = phiB/100;
          phiC = phiC/100;
          var TPoro = InterP + IntraP * (1-InterP);
          // Viscosity calculation
          if (!solventc) {
            switch(solventType){
                case "ACN":
                visco = Math.exp(phiB*(-3.476+726/Temp)+(1-phiB)*(-5.414+1566/Temp)+phiB*(1-phiB)*(-1.762+929/Temp));
                psi = 1*phiB + 2.6*(1-phiB);
                MB = 41.05*phiB+ 18.015*(1-phiB);
                NFactor = 0.5;
                break;
                case "MEOH":
                visco = Math.exp(phiB*(-4.597+1211/Temp)+(1-phiB)*(-5.961+1736/Temp)+phiB*(1-phiB)*(-6.215+2809/Temp));
                psi = 1.9*phiB + 2.6*(1-phiB);
                MB = 32.04*phiB + 18.015*(1-phiB);
                NFactor = 0.85;
                break;
              }
            }
            else{
                visco = Math.exp(phiB*(-3.476+726/Temp)+(1-phiB-phiC)*(-5.688+1651/Temp)+phiB*(1-phiC-phiB)*(-1.762+929/Temp)
                +phiC*(-4.597+1211/Temp)+phiC*(1-phiC-phiB)*(-6.215+2809/Temp));
                psi = 1*phiB + 1.9*phiC + 2.6*(1-phiB-phiC);
                MB = 41.05*phiB + 32.04*phiC + 18.015*(1-phiB-phiC);
                NFactor = 0.70;
            };

          // Retention time calculation
          var tR = (RtFactor[i]+1)*t0;

          // Reduced velocity calculation
          var ue = (TPoro/InterP)*L/t0/600;
          var Dm = 7.4e-8*(Math.sqrt(psi*MB))*Temp/(visco*Math.pow(compdata[i][2],0.6));
          var vr = ue*dP/Dm/10000;

          // Efficiency model
//           var Ncoeff= [5.109e-6,0.0098326];
//           var sigma2i = tR*tR*dP/L/1000*(A+B/vr+C*vr)+Ncoeff[0]*(Vinj/FlowRate)*(Vinj/FlowRate)+Ncoeff[1];
//          console.log('compdata',(C*compdata[i][7]*vr);
          var Ncoeff=[3.88e-6,-1.8e-10,1.0e-4];
          //console.log('FR',FlowRate)
          //console.log('dP',dP)
          //console.log('L',L)

          var sigma2 = (FlowRate*FlowRate*tR*tR*dP/L)
                        *(A*compdata[i][5]*Math.pow(vr,0.33)+B*compdata[i][6]/vr+C*compdata[i][7]*vr)
                        +Ncoeff[0]*(Vinj*Vinj)+Ncoeff[1]*Math.pow(InterDiam,4)+Ncoeff[2];
          //console.log('sigma2',sigma2)
          var sigma = Math.sqrt(sigma2/FlowRate/FlowRate)*NFactor;
          var Efficiency = (tR/sigma)*(tR/sigma);
          var HETP = L/Efficiency;

          //EffResults = [sigma,N,t0,tR,visco,HETP,Vm]
          EffResults[0] = sigma;
          EffResults[1] = Efficiency;
          EffResults[2] = HETP;
          EffResults[3] = tR;
          EffResults[4] = visco;
          return EffResults;
      }

      this.bpfuncs=function(visco,L,FR,dP,InterDiam){
          //Return backpressure value for the run
          //Input
          //visco - viscosity (cP)
          //L - column length (mm)
          //FR - flow rate (mL/min)
          //dP - column particle size (um)
          //InterDiam - column internal diameter (mm)
          //Output
          //BP - backpressure (psi)
          var BP;
          BP = 4000*L*FR*visco/(dP*dP)/(InterDiam*InterDiam);
          return BP;
      }
      this.senfuncs=function(SampleConc,Vinj,Efficiency,RtFactor,Vm,sigma,i){
          //Return AUC value for compounds
          //Input
          //Conc - Sample concentration for the compounds (mg/ml) [6x1]
          //Vinj - injection volume (uL)
          //N - column efficiency (-) [6x1]
          //k - retention factor (-) [6x1]
          //Absorb - Absorbivity of compounds (-) [6x1]
          //Vm - column void volume (mL)
          //sigma - standard deviation (min)
          //Output
          //AUC - Area under curve (-)
          var Cs,H;
          var AUC=[];
          Cs = SampleConc*Vinj*Math.sqrt(Efficiency)/(Vm*(1+RtFactor));
          H = compdata[i][3]*Cs;
          //console.log("Height",H)
          /*if (H>4e6){
              H = 4e6;
          }*/
          AUC[0] = 37.46*(4*sigma)*H;
          AUC[1] = H;
          return AUC;
      }

      this.normdisfun=function(tR,sigma,AUC,H,x_max){
          //Density function
          var datapoint = 2000;
          var i,n,dx,densityFunc=[],densityFunc2=[],x=[];
          var dy1 = [], dy2 = [], Iy=[];
          var normdis=[];
          var x_d;
          var y = Array.apply(null, Array(datapoint)).map(Number.prototype.valueOf,0);
          var y2 = Array.apply(null, Array(datapoint)).map(Number.prototype.valueOf,0);
          dx=x_max/datapoint;
          for (n=0;n<datapoint;n++){
            x_d = n*dx;
              x[n]=parseFloat(x_d).toFixed(3);
              for (i=0;i<6;i++){
                  densityFunc[n]=1/Math.sqrt(8*Math.PI*sigma[i]*sigma[i])*Math.exp(-(dx*n-tR[i])*(dx*n-tR[i])/(3*sigma[i]*sigma[i]))*AUC[i];
                  densityFunc2[n]=1/Math.sqrt(8*Math.PI*sigma[i]*sigma[i])*Math.exp(-(dx*n-tR[i])*(dx*n-tR[i])/(3*sigma[i]*sigma[i]))*H[i];
                  y[n] = Math.round(y[n]+densityFunc[n]*1.65);
                  y2[n] = Math.round(y2[n]+densityFunc2[n]/16.5);
              }
          }
          // Calculating first and second derivate
              //Forward
              dy1[0]=(-y[2]+4*y[1]-3*y[0])/(2*dx);
              dy2[0]=(-y[3]+4*y[2]-5*y[1]+2*y[0])/(dx*dx);
              Iy[0]=0;
              //Central difference
              for (n=1;n<datapoint-1;n++){
                dy1[n]=(y[n+1]-y[n-1])/(2*dx);
                dy2[n]=(y[n+1]-2*y[n]+y[n-1])/(dx*dx);
                Iy[n]=Math.round(Iy[n-1]+(y[n-1]+y[n])*dx/2);
              }
              //Backward
              dy1[datapoint-1]=(3*y[datapoint-1]-4*y[datapoint-2]+y[datapoint-3])/(2*dx);
              dy2[datapoint-1]=(2*y[datapoint-1]-5*y[datapoint-2]+4*y[datapoint-3]-y[datapoint-4])/(dx*dx);
              Iy[datapoint-1]=Math.round(Iy[datapoint-2]+(y[datapoint-2]+y[datapoint-1])*dx/2);

              //console.log("dy1",dy1)
              //console.log("dy2",dy2)
              //console.log("Iy",Iy)
          // Calculating cummulative peak area

          normdis[0]=x;
          normdis[1]=y;
          normdis[2]=y2;
          normdis[3]=dy1;
          normdis[4]=dy2;
          normdis[5]=Iy;

          return normdis;
      }

      this.peakdet = function(x,y,y2,dy1,dy2,Iy,datapoint){
        var peaktable = [];
        var peakValue_index =[],peakwidth_index=[];
        var peakno=[],peaktR=[],peakheight=[],peakdy2=[];
        var peaktemp1=[],peaktemp2=[],peaktemp=[];
        var peakindex=[],valleyindex1=[],valleyindex2=[];
        var peakwidth=[],peakarea=[]
        var zerody,zeroh,w;
        var threshold = 50000;
        var m=0,k=0,m1=0,m2=0,i,n,k1;
        for (n=0;n<datapoint-1;n++){
          zerody = dy1[n]*dy1[n+1]
          zeroh = (y[n]-threshold)*(y[n+1]-threshold);
          if (zeroh < 0) {
            peakwidth_index[k]=n;
            k = k+1;
          }
          if (zerody <0) {
            peakValue_index[m]=n;
            m = m+1;
          }
        }
        for (i=0;i<m;i++){
          if(dy2[peakValue_index[i]]<0){
            m1 = m1+1;
            peakno[m1-1]=m1;
            peakindex[m1-1]=peakValue_index[i];
            peaktR[m1-1]=x[peakValue_index[i]];
            peakheight[m1-1]=y2[peakValue_index[i]];
        } else{
          m2 = m2+1;
          valleyindex1[m1-1]=peakValue_index[i]
          peaktemp1[m2-1]=x[peakValue_index[i]];
        }
        }
        for (i=0;i<k;i++){
          valleyindex2[i]=peakwidth_index[i];
          peaktemp2[i]=x[peakwidth_index[i]];
        }
//        console.log(peakValue_index)
//        console.log(peakwidth_index)
        peaktemp = peakindex.concat(valleyindex1,valleyindex2);
        peaktemp = peaktemp.sort(function(a, b){return a-b})
        n = 0;
        for (i=0;i<peaktemp.length;i++){
          if (peakindex[n]==peaktemp[i]){
            w = x[peaktemp[i+1]]-x[peaktemp[i-1]];
            peakwidth[n]=parseFloat(w).toFixed(3);
            peakarea[n]=Iy[peaktemp[i+1]]-Iy[peaktemp[i-1]];
            n = n+1;
          }
        }

        peaktable[0]=peakno;
        peaktable[1]=peaktR;
        peaktable[2]=peakheight;
        peaktable[3]=peakwidth;
        peaktable[4]=peakarea;
        console.log(peaktable);
//        console.log(peakindex);
//        console.log(peaktemp);
        return peaktable;
      }

      this.peakTab = function(peaktable,peakno){
        var peakArray=[];
        var peakNum,peaktR,peakH,peakW,peakAUC;
        var i;
        for (i=0;i<peakno;i++){
          peakNum = peaktable[0][i];
          peaktR = peaktable[1][i];
          peakH = peaktable[2][i];
          peakW = peaktable[3][i];
          peakAUC = peaktable[4][i];
          peakArray[i] = {peakNum,peaktR,peakW,peakH,peakAUC};
        }
        console.log("peakArray",peakArray);
        return peakArray;
      }

      this.xydata=function(x,y,dataNo){
          var i,dataset=[];
          for (i=0;i<dataNo;i++){
            if (y[i]/50000>4000){
              dataset[i] = {x:x[i],y:4000};
            }else{
              dataset[i] = {x:x[i],y:y[i]/50000};
            }

          }
          return dataset;
      }

      this.xydata2=function(x,y,dataNo){
          var i,dataset=[];
          for (i=0;i<dataNo;i++){
              dataset[i] = {x:x[i],y:y[i]};
          }
          return dataset;
      }

      // Gradient functions
      this.concgrad=function(tstamp,concp,tpoint){
          //Return gradient profile based on user input profile
           var grads=[];
           var i;
           //console.log("t",tstamp)
           //console.log("c",this.concp)
           //console.log("tp",tpoint)
           for (i=0;i<(tpoint-1);i++){
               grads[i]=(concp[i+1]-concp[i])/(tstamp[i+1]-tstamp[i]);
           }
           return grads;
      }

      concfuncs=function(t,tstamp,concp,tpoint,grad){
          //Concentration time function
          var phi;
          if (t >= tstamp[tpoint-1]){
                  phi = concp[tpoint-1];
              }
          else {
              var j;
              for (j=1;j<tpoint;j++){
                  if (t < tstamp[j]){
                      phi = grad[j-1]*(t-tstamp[j-1]) + concp[j-1];
                      break
                  }
              }
          }
          return phi;
      }

      // Retention time
      rtfuncg=function(t,i,tpoint,grads,coeff,tstamp,concp){
          //Retention factor time function
          //Input unit conversion
          //concfuncs = this.concfuncs;

          var RtFactori;
          /*console.log("tstamp2",tstamp)
          console.log("concp2",concp)
          console.log("tpoint2",tpoint)
          console.log("grads2",grads)*/
          var phi = concfuncs(t,tstamp,concp,tpoint,grads)/100;
          //console.log("phi",phi)
          var Temp1 = Temp+273.15;
          //console.log("Temp",Temp1)
          switch(solventType){
              case "ACN":var PNM = 1-2.068*phi/(1+1.341*phi);break;
              case "MEOH":var PNM = 1-1.33*phi/(1+0.47*phi);break;
              }
          //Retention model
          var logki = coeff[i][0] + coeff[i][1]/Temp1 + coeff[i][2]*PNM*PNM + coeff[i][3]*PNM
              + Math.log10(1 + Math.pow(10,(pH-compdata[i][4]-phi*compdata[i][1]))
              /(1+Math.pow(10,(pH-compdata[i][4]-phi*compdata[i][1])))*(compdata[i][0]-1));
          //console.log("logki",logki)
          return RtFactori = Math.pow(10,logki);
      }

      effuncg=function(t,i,coeff,phi,k,t0){
          //Efficiency time function
          //Unit conversion
          var Temp1 = Temp+273.15;
          var TPoro= InterP + IntraP * (1-InterP);
          //Viscosity calculation
          var visco,psi,MB;
          switch(solventType){
              case "ACN":
              visco = Math.exp(phi*(-3.476+726/Temp1)+(1-phi)*(-5.414+1566/Temp1)+phi*(1-phi)*(-1.762+929/Temp1));
              psi = 1*phi + 2.6*(1-phi);
              MB = 41.05*phi+ 18.015*(1-phi);
              break;
              case "MEOH":
              visco = Math.exp(phi*(-4.597+1211/Temp1)+(1-phi)*(-5.961+1736/Temp1)+phi*(1-phi)*(-6.215+2809/Temp1));
              psi = 1.9*phi + 2.6*(1-phi);
              MB = 32.04*phi + 18.015*(1-phi);
              break;
          }
          //Instaneous retention time calculation
          var tR = (k+1)*t0;
          //console.log("RT",RTimei)
          //Reduced velocity calculation
          var ue = (TPoro/InterP)*L/t0/600;
          var Dm = 7.4e-8*(Math.sqrt(psi*MB))*Temp1/(visco*Math.pow(compdata[i][2],0.6));
          var vr = ue*dP/Dm/10000;
          // Instaneous HETP calculation
          var Ncoeff= [5.109e-6,0.0098326];
          var sigma2i = tR*tR*dP/L/1000*(A+B/vr+C*vr)+Ncoeff[0]*(Vinj/FlowRate)*(Vinj/FlowRate)+Ncoeff[1];
          var sigmai = Math.sqrt(sigma2i);
          var Efficiencyi = (tR/sigmai)*(tR/sigmai);
          var HETPi = L/Efficiencyi;
          return HETPi;
      }

      this.bpfuncg=function(t_max,datapoint,tpoint,grads){
          //Viscosity calculation
          var Temp=this.systemPara.Temp+273.15;
          var n,BP=[],t=[];
          var dt=t_max/datapoint;
          for (n=0;n<datapoint;n++){
              t[n]=n*dt;
              var phi=concfuncs(t[n],this.tstamp,this.concp,tpoint,grads)/100;
              switch(solventType){
                  case "ACN":
                  var visco = Math.exp(phi*(-3.476+726/Temp)+(1-phi)*(-5.414+1566/Temp)+phi*(1-phi)*(-1.762+929/Temp));
                  break;
                  case "MEOH":
                  var visco = Math.exp(phi*(-4.597+1211/Temp)+(1-phi)*(-5.961+1736/Temp)+phi*(1-phi)*(-6.215+2809/Temp));
                  break;
              }
              BP[n]=4000*this.columnPara.L*this.FlowRate*visco/(this.columnPara.PS*this.columnPara.PS)/(this.columnPara.ID*this.columnPara.ID);
          }
          var BPResults=[];
          BPResults[0]=t;
          BPResults[1]=BP;
          return BPResults;
      }

      this.senfuncg=function(Conc,Vinj,N,k,Vm,sigma,i){
          //Return AUC value for compounds
          //Input
          //Conc - Sample concentration for the compounds (mg/ml) [6x1]
          //Vinj - injection volume (uL)
          //N - column efficiency (-) [6x1]
          //k - retention factor (-) [6x1]
          //Absorb - Absorbivity of compounds (-) [6x1]
          //Vm - column void volume (mL)
          //sigma - standard deviation (min)
          //Output
          //AUC - Area under curve (-)
          var Cs,H,AUC=[];
          Cs = Conc*Vinj*Math.sqrt(N)/(Vm*(1+k));
          H = compdata[i][3]*Cs;
          /*if (H>4e6){
              H = 4e6;
          }*/
          AUC[0] = 37.46*(4*sigma)*H;
          AUC[1] = H;
          return AUC;
      }

      lambdafun=function(zValue,tValue,u0,tpoint,grads,coeff,tstamp,concp,itera){
          var lambda;
          lambda = (1+rtfuncg(tValue-zValue/u0,itera,tpoint,grads,coeff,tstamp,concp))/u0;
          return lambda;
          }

      this.gradodefunc=function(zValue,sValues){
        /*
        % System of ordinary derivative equations
        % s(1) - t
        % s(2) - sigma^2
        % dsdz(1) - dt/dz
        % dsdz(2) - d(sigma^2)/dz
        */
        var dt = 1e-6;
        //var lambdafun = this.lambdafun;
        // var HETPfunc = this.HETPfunc;
        //console.log("u0",u0);
        //console.log("itera",itera);
        //console.log("tpoint",tpoint)
        //console.log("grads",grads)
        //console.log("coeff",coeff)
        //console.log("zValue",zValue)
        //console.log("sValues",sValues[0]+dt)
        //console.log("Lambdafun",lambdafun(zValue,sValues[0]+dt,u0,tpoint,grads,coeff,itera))

        var dlambdadt = (lambdafun(zValue,sValues[0]+dt,u0,tpoint,grads,coeff,tstamp,concp,itera)
                        -lambdafun(zValue,sValues[0]-dt,u0,tpoint,grads,coeff,tstamp,concp,itera))
                        /(dt*2);
        //console.log("dl",dlambdadt)
        var dlambdadt2 = (lambdafun(zValue,sValues[0]+dt,u0,tpoint,grads,coeff,tstamp,concp,itera)
                         -2*lambdafun(zValue,sValues[0],u0,tpoint,grads,coeff,tstamp,concp,itera)
                         +lambdafun(zValue,sValues[0]-dt,u0,tpoint,grads,coeff,tstamp,concp,itera))
                         /(dt*2);
        var dsdz =[];
        dsdz[0] = lambdafun(zValue,sValues[0],u0,tpoint,grads,coeff,tstamp,concp,itera);
        dsdz[1] = HETPfunc(zValue,sValues[0],u0,t0,tpoint,coeff,grads,tstamp,concp,itera)
                  *lambdafun(zValue,sValues[0],u0,tpoint,grads,coeff,tstamp,concp,itera)
                  *lambdafun(zValue,sValues[0],u0,tpoint,grads,coeff,tstamp,concp,itera)
                  +2*sValues[1]*dlambdadt;//+ 16*dlambdadt2;
        return dsdz;
        }

      HETPfunc=function(zValue,tValue,u0,t0,tpoint,coeff,grads,tstamp,concp,itera){
        var HETP;
        //var rtfuncg = this.rtfuncg;
        //var effuncg = this.effuncg;
        //console.log("coeff",coeff)
        //console.log("k",rtfuncg(tValue,itera,tpoint,grads,coeff))
        HETP = effuncg((tValue-zValue/u0),itera,coeff,
        concfuncs(tValue,tstamp,concp,tpoint,grads)/100,
        rtfuncg(tValue,itera,tpoint,grads,coeff,tstamp,concp),
        t0);
        return HETP;
        }

        this.drawGRAD = function(chromatogram_grad,backPressure_grad,concProfile){
          this.chartType = 'scatter';
          this.chartData = {
                datasets: [
                    {
                    fill:false,
                    label: 'Chromatogram',
                    yAxisID:'Absorption',
                    data: chromatogram_grad,
                    borderColor: 'rgb(51, 102, 255)',
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                    cubicInterpolationMode:'monotone',
                    steppedLine:'after'
                  },{
                    fill:false,
                    label: 'Backpressure (psi)',
                    yAxisID:'Backpressure',
                    data: backPressure_grad,
                    borderColor: 'rgb(255, 80, 80)',
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                  },
                  {
                    fill:false,
                    label: 'Concentration profile (%)',
                    yAxisID:'Concentration',
                    data: concProfile,
                    borderColor: 'rgb(0, 153, 51)',
                    lineTension:0,
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                  },
                  {
                    fill:false,
                    label: 'Void time',
                    xAxisID:'Void',
                    data: [{x:t0,y:0},{x:t0,y:4000}],
                    borderColor: 'rgb(150, 150, 150)',
                    borderDash: [5, 5],
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                  }
                ]
                };

          this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0
                      },
              scales: {
                    xAxes: [{
                        type: 'linear',
                        position: 'bottom',
                        id: 'Void'
                    }],
                    yAxes:[{
                      position:'left',
                      id:"Absorption",
                      ticks:{
                        max:this.maxabs,
                        min:0
                        }
                      },{
                    position:'right',
                    id:"Backpressure",
                    gridLines:{drawOnChartArea:false},
                    ticks:{
                      max:6e3,
                      min:0
                    }},{
                      position:'right',
                      id:"Concentration",
                      gridLines:{drawOnChartArea:false},
                      ticks:{
                        max:120,
                        min:0
                    }}]
                }
            };
            this.displayChart=true;
          //toggles chart //this.displayChart=!this.displayChart;
        } //END drawGRAD function

        this.drawISO = function( chromatogram_iso, backPressure_iso, t0 ) {
          this.chartType = 'scatter';
          this.chartData = {
                datasets: [
                    {
                    fill:false,
                    label: 'Chromatogram',
                    yAxisID:'Absorption',
                    data: chromatogram_iso,
                    borderColor: 'rgb(51, 102, 255)',
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                    cubicInterpolationMode:'monotone',
                    steppedLine:'after'
                  },{
                    fill:false,
                    label: 'Backpressure (psi)',
                    yAxisID:'Backpressure',
                    data: [{x:0,y:backPressure_iso},{x:this.systemPara.AcqTime,y:backPressure_iso}],
                    borderColor: 'rgb(255, 80, 80)',
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                  },
                  {
                    fill:false,
                    label: 'Void time',
                    xAxisID:'Void',
                    data: [{x:t0,y:0},{x:t0,y:4000}],
                    borderColor: 'rgb(150, 150, 150)',
                    borderDash: [5, 5],
                    showLine:true,
                    pointRadius:0,
                    borderWidth:2,
                  }
                ]
                };
          this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0
                      },
              scales: {
                    xAxes: [{
                        type: 'linear',
                        position: 'bottom',
                        id: 'Void'
                    }],
                    yAxes:[{
                      position:'left',
                      id:"Absorption",
                      ticks:{
                        min: 0,
                        max: this.maxabs,
                        }
                      },{
                    position:'right',
                    id:"Backpressure",
                    gridLines:{drawOnChartArea:false},
                    ticks:{
                      max:6e3,
                      min:0
                    }
                    }]
                }
            };
            this.displayChart=true;
          //toggles chart //this.displayChart=!this.displayChart;
        } // end drawISO function

      //FUNC ABOVE ------------------------------------------------------------------------------------------------------------------------
      //Cal below -------------------------------------------------------------------------------------------------------------------------
      //Calling from database
      this.calFunction = function( tpoint, coeff, tstamp, concp ) {
      // console.log(this.coeffcall());
      var samplePara = [this.SULconc,this.PIRconc,this.PHEconc,this.NAPconc,this.KETconc,this.DICconc];//[SUL,PIR,PHE,NAP,KET,DIC]
      //var samplePara = [0.1,0.1,0.1,0.1,0.1,0.1]; //[SUL,PIR,PHE,NAP,KET,DIC]
      //Void time and void volume
      var VoidTV = this.VoidTVfunc();
      var Vm=VoidTV[0];

      t0=VoidTV[1];
      u0=VoidTV[2];

      if(this.HPLCmode == '0') { // Isocratic moode
          /*if(!this.solventc){// Single solvent
            this.solventPara.Type = this.solventbType;
            this.solventPara.pH = this.pHB;
            this.solventPara.Conc = this.prentB;
          }else{// Multiple solvents
            this.solventPara.Type = "MIX";
            this.solventPara.pH = this.pHB;
            this.solventPara.Conc = this.prentB; //Not fixed
          };*/
            //Looping for each compound
            //Defining variables
            var Sen_iso=[],RF_iso=[],EffResults_iso=[],sigma_iso=[],EffN_iso=[],RTime_iso=[],HETP=[],AUC_iso=[],H_iso=[];
            for (itera=0;itera<6;itera++){
            //Retention calculation
            RF_iso[itera]=this.rtfunc2(coeff,this.prentB,this.solventPara.pH,this.systemPara.Temp,itera,this.solventString,this.phaseString,this.solventc,this.prentC);
            //Efficiency calculation
            EffResults_iso=this.effuncs(this.FlowRate,RF_iso,this.columnPara.PS,this.columnPara.L,this.columnPara.ID,this.systemPara.Vinj,this.advancedPara.A,
            this.advancedPara.B,this.advancedPara.C,this.prentB,this.systemPara.Temp,this.advancedPara.InterP,this.advancedPara.IntraP,t0,itera,this.solventString,this.solventc,this.prentC);
            sigma_iso[itera]=EffResults_iso[0];
            EffN_iso[itera]=EffResults_iso[1];
            HETP[itera]=EffResults_iso[2];
            RTime_iso[itera]=EffResults_iso[3];
            //Sensitivity calculation
            Sen_iso[itera]=this.senfuncs(samplePara[itera],this.systemPara.Vinj,EffN_iso[itera],RF_iso[itera],Vm,sigma_iso[itera],itera)
            AUC_iso[itera]=Sen_iso[itera][0];
            H_iso[itera]=Sen_iso[itera][1];
            console.log("AUC_iso",AUC_iso);
            console.log("H_iso",H_iso);
            //console.log("N",EffResults_iso[1])
          }
            //Backpressure
            var visco=EffResults_iso[4];
            var backPressure_iso=this.bpfuncs(visco,this.columnPara.L,this.FlowRate,this.columnPara.PS,this.columnPara.ID);
            var normdis_iso= this.normdisfun(RTime_iso,sigma_iso,AUC_iso,H_iso,this.systemPara.AcqTime);
            var peaktable = this.peakdet(normdis_iso[0],normdis_iso[1],normdis_iso[2],normdis_iso[3],normdis_iso[4],normdis_iso[5],normdis_iso[0].length);
            this.peakArray = this.peakTab(peaktable,peaktable[0].length);

            // -------- Data Acquisition Tab - Table variables
                this.displayedColumns = ['peakNum', 'peaktR', 'peakW', 'peakH', 'peakAUC'];
                this.peakData = new MatTableDataSource<PeakElement>(this.peakTab(peaktable,peaktable[0].length));

                this.type = 'line';
                this.options = {
                    responsive: true,
                    maintainAspectRatio: false
                };

            var chromatogram_iso = this.xydata(normdis_iso[0],normdis_iso[1],normdis_iso[0].length);
            //Checking point
            //console.log("ISO Chromo Data",chromatogram_iso);
            // Plotting isocratic
            this.drawISO( chromatogram_iso, backPressure_iso, t0 );
            /*var Chart1 = new Chart(this.Chart1,{
              type:this.chartType,
              data:this.chartData,
              options:this.chartOptions
            })*/

      }else{// Gradient mode
        //Additional parameteres
        /*var this.tstamp = [0,3,8,20];
        var concp = [30,30,100,100];
        var tpoint = this.tstamp.length;*/

        //Plot concentration time profile
        itera = 0;
        console.log("tpoint",tpoint)
        grads = this.concgrad(this.tstamp,this.concp,tpoint);
        console.log("grads",grads)
        Temp = this.systemPara.Temp;
        pH = this.solventPara.pH;
        solventType = this.solventString;
        InterP = this.advancedPara.InterP;
        IntraP = this.advancedPara.IntraP;
        L = this.columnPara.L;
        dP = this.columnPara.PS;
        A = this.advancedPara.A; B = this.advancedPara.B; C = this.advancedPara.C;
        Vinj = this.systemPara.Vinj;
        FlowRate = this.FlowRate;

        var concProfile=this.xydata2(this.tstamp,this.concp,this.tstamp.length);
        //Backpressure
        var BPResults=this.bpfuncg(this.systemPara.AcqTime,500,tpoint,grads);
        var backPressure_grad=this.xydata2(BPResults[0],BPResults[1],BPResults[0].length);
        console.log("GRAD Conc",concProfile);

        //Looping for each compound
        var Sen_grad=[],RF_grad=[],sigma_grad=[],AUC_grad=[],H_grad=[],EffN_grad=[],RTime_grad=[];
        console.log("Gradeofunc",this.gradodefunc(1,[1,0.5]))
        for (itera=0;itera<6;itera++){
        //ode solver
        var odesolution=numeric.dopri(0,this.columnPara.L,[0,0],this.gradodefunc,1e-6,2000);
        var odelength=odesolution.x.length;
        var RFi_grad=odesolution.y[odelength-1][0];
        var sigmai_grad=Math.sqrt(odesolution.y[odelength-1][1]);
        RF_grad[itera]=RFi_grad;
        sigma_grad[itera]=sigmai_grad;
        RTime_grad[itera]=t0*(1+RF_grad[itera]);
        EffN_grad[itera]= (RTime_grad[itera]/sigma_grad[itera])*(RTime_grad[itera]/sigma_grad[itera]);
        Sen_grad[itera]=this.senfuncg(samplePara[itera],this.systemPara.Vinj,EffN_grad[itera],RF_grad[itera],Vm,sigma_grad[itera],itera)
        AUC_grad[itera]=Sen_grad[itera][0];
        H_grad[itera]=Sen_grad[itera][1];
        }
        // console.log("GRAD RT",RF_grad);
        // console.log("GRAD sigma",sigma_grad);
        // console.log("GRAD AUC",AUC_grad);
        var normdis_grad= this.normdisfun(RTime_grad,sigma_grad,AUC_grad,H_grad,this.systemPara.AcqTime);

        var chromatogram_grad = this.xydata(normdis_grad[0],normdis_grad[1],normdis_grad[0].length);
        var peaktable = this.peakdet(normdis_grad[0],normdis_grad[1],normdis_grad[2],normdis_grad[3],normdis_grad[4],normdis_grad[5],normdis_grad[0].length);
        this.peakArray = this.peakTab(peaktable,peaktable[0].length);

        // -------- Data Acquisition Tab - Table variables
            this.displayedColumns = ['peakNum', 'peaktR', 'peakW', 'peakH', 'peakAUC'];
            this.peakData = new MatTableDataSource<PeakElement>(this.peakTab(peaktable,peaktable[0].length));

            this.type = 'line';
            this.options = {
                responsive: true,
                maintainAspectRatio: false
            };

        //Checking point
        // console.log('GRAD Chromo Data',chromatogram_grad);
        // Plotting gradient
        this.drawGRAD(chromatogram_grad,backPressure_grad,concProfile);
      };
    //};
  /*console.log("columnPara",this.columnPara);
  console.log("solventPara",this.solventPara);
  console.log("advancedPara",this.advancedPara);
  console.log("systemPara",this.systemPara);
  console.log("Chromatogram",chromatogram_iso)*/

}
}


public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    console.log(tabChangeEvent.index);
    if (tabChangeEvent.index == 1) {
      if (this.tabVisited==false) {
        this.HPLCmode = '0';
        this.tabVisited = true;
      }
    }
    if (tabChangeEvent.index == 2) {
      // console.log("THIS IS THE TAB!");
      this.tstamp = this.tstamp
      this.concp = this.concp;
      this.LCtype = 'line';
      this.LCdata = {
        labels: this.tstamp,
        datasets: [
          {
            borderColor: 'rgb(230, 230, 230)',
            borderWidth:2,
            label: "Solvent Conc %",
            data: this.concp,
            lineTension:0,
          }
        ]
        };
    };

}

ngAfterViewInit() {
// console.log('afterViewInit => ', this.tabGroup.selectedIndex);
// console.log('afterViewInit => ', normdis[0]);


}

ngOnInit() {
  // this.interval = Observable.interval(0).take(1).subscribe(() => this.onClickRun() );
}

ngOnDestroy() {
  // this.interval.unsubscribe();
}

}


// export interface peakElement {
//        peakNum: number;
//        peaktR: string;
//        peakW: string;
//        peakH: number;
//        peakAUC: number;
//      };

export interface LCtable {
  time: number;
  solvent: number;
}

// const LC_DATA:
// LCtable[] = [
//   { time: tstamp, solvent: 1.0079 }
// ]
// this.LCarray;
// ;
